import React from 'react';

import { TextField, makeStyles } from '@gogame/components';
import { withFormField } from '@gogame/form';

const useStyles = makeStyles(() => ({
  input: {
    '& .MuiInputBase-inputAdornedEnd': {
      paddingRight: '0 !important',
    },
  },
}));

export const TimeLimitInput = withFormField({ padding: 0 })(
  ({ name, value, onChange, error, valuePropKey }) => {
    const classes = useStyles();

    return (
      <TextField
        className={classes.input}
        name={name}
        value={value?.[valuePropKey]}
        error={error?.[valuePropKey]}
        label={'Completion time'}
        placeholder={'0'}
        type={'days'}
        InputLabelProps={{
          shrink: true,
        }}
        required={true}
        onChange={(e) => {
          onChange(e, { ...value, [valuePropKey]: e.target.value });
        }}
      />
    );
  }
);
export default TimeLimitInput;
